import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { RouteComponentProps } from 'react-router-dom'

export default class MaintenancePage extends React.Component<
  RouteComponentProps<{}>,
  {}
> {
  public render() {
    return (
      <DocumentTitle title='Work In Progress'>
        <div className='container d-flex flex-column h-100 mt-3'>
          <div className='row h-100 justify-content-center align-items-center'>
            <div>
              <img
                src='/images/HB_Logo_Square_150.png'
                width={150}
                style={{ display: 'block', margin: 'auto' }}
              />
              <p className='mt-4'>
                This page is not done yet but will be soon. Check back later!
              </p>
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}
